module.exports = __webpack_public_path__ + "static/img/yanzhengma.62ace1b9.png";